<template>
    <section class="page-section">
        <div class="drop-zones-header">
            <div :class="{'activated':viewState.activateClocks}">Clocks</div>
            <div :class="{'activated':viewState.activatePlaylists}">Playlists</div>
            <div :class="{'activated':viewState.activatePodcasts}">Podcasts</div>
        </div>
        <WaitingBlock v-if="isLoadingDayTemplateItems"></WaitingBlock>
        <div v-else class="drop-zones" v-on:drop="drop" v-on:dragover="dragOver">
            <div class="time-line">
                <div v-for="interval in intervals" :key="interval.id" class="time-line-row">
                    <div class="time-line-label">
                        {{ interval.timeStart.format("HH:mm") }}
                    </div>
                    <div class="helper"></div>
                </div>
            </div>
            <div class="drop-zones-container">
                <div class="drop-zone-clocks" @mousemove="onScheduledItemMove" @mouseup.prevent.stop="onScheduledItemMoved">
                    <template v-if="currentDayTemplateItems!=null">
                        <BaseScheduledItemCard v-for="clock in currentDayTemplateItems.clocks"
                                               :key="clock.recordUid"
                                               :type="'clock'" :scheduledItem="clock"
                                               @onScheduledItemMoving="onScheduledItemStartMoving"
                                               @onScheduledItemEditing="onScheduledItemEditing"
                                               @onScheduledItemDeleting="onScheduledItemDeleting"
                                               @mouseup.prevent.stop="onScheduledItemMoved">
                        </BaseScheduledItemCard>
                    </template>
                </div>
                <div class="drop-zone-playlists" @mousemove="onScheduledItemMove" @mouseup.prevent.stop="onScheduledItemMoved">
                    <template v-if="currentDayTemplateItems!=null">
                        <BaseScheduledItemCard v-for="pl in currentDayTemplateItems.playlists"
                                               :key="pl.recordUid"
                                               :type="'playlist'"
                                               :scheduledItem="pl"
                                               @onScheduledItemMoving="onScheduledItemStartMoving"
                                               @onScheduledItemEditing="onScheduledItemEditing"
                                               @onScheduledItemDeleting="onScheduledItemDeleting"
                                               @mouseup.prevent.stop="onScheduledItemMoved">
                        </BaseScheduledItemCard>
                    </template>
                </div>
                <div class="drop-zone-podcasts" @mousemove="onPodcastMove" @mouseup.prevent.stop="onScheduledItemMoved">
                    <template v-if="currentDayTemplateItems!=null">
                        <BaseScheduledItemCard v-for="po in currentDayTemplateItems.podcasts" :key="po.recordUid"
                                               :type="'podcast'"
                                               :scheduledItem="po"
                                               @onScheduledItemMoving="onScheduledItemStartMoving"
                                               @onScheduledItemEditing="onScheduledItemEditing"
                                               @onScheduledItemDeleting="onScheduledItemDeleting"
                                               @mouseup.prevent.stop="onScheduledItemMoved">
                        </BaseScheduledItemCard>
                    </template>
                </div>
            </div>
        </div>
        <ScheduledItemEditionCard ref="item-edit" v-if='scheduledItem'
                                  @onScheduledItemEdited="onScheduledItemEdited"
                                  @onCancel="scheduledItem = null"
                                  :scheduledItems="currentDayTemplateItems"
                                  :scheduledItem="scheduledItem">
        </ScheduledItemEditionCard>
    </section>
</template>

<script>
    import store from '@/store/index.js';
    import Bootstrap from 'bootstrap-vue';
    import WaitingBlock from'@/components/common/WaitingBlock.vue';
    import ItemListCard from'@/components/common/PlannerItemListCard.vue';

    import BaseScheduledItemCard from "../DayTemplates/BaseScheduledItemCard";
    import Enums from '../../apis/_enums'
    import Translations from '@/store/translations';
    import { mapState, mapMutations, mapActions } from 'vuex';
    import Vue from 'vue';
    import Moment from 'moment';
    //import VueDraggableResizable from 'vue-draggable-resizable';
    import EventBus from '@/eventbus';
    import ScheduledItemEditionCard from './ScheduledItemEditionCard'
    import { HTTP } from "@/utils/http";
    import Apis from "@/apis";
    import {safeObj} from "@/utils/safeObj";

    const MOVING_MODES = {
        RESIZE: "resize", MOVE: 'move'
    }
    export default {
        name: "DayTemplateDetails",
        store,
        //------------------------------------------------------------------------------------------------------------------------------------------------
        components: { WaitingBlock, ItemListCard, BaseScheduledItemCard, ScheduledItemEditionCard },
        //------------------------------------------------------------------------------------------------------------------------------------------------
        //------------------------------------------------------------------------------------------------------------------------------------------------
        mounted() {
            // EventBus.$on("addClockToDayTemplate", this.addClock);
            // EventBus.$on("addPodcastToDayTemplate", this.addPodcast);
            // EventBus.$on("addPlaylistToDayTemplate", this.addPlaylist);
            // EventBus.$on("addPromoToDayTemplate", this.addPodcast);

            // EventBus.$on('drag', this.drag);
            EventBus.$on('dragStart', this.dragStart);
            EventBus.$on('dragEnd', this.dragEnd);

            this.stationUid = this.$route.params.stationUid;
            this.dayTemplateUid = this.$route.params.dayTemplateUid;
            this.loadDayTemplate();
            this.loadDayTemplateScheduledItemList();
        },
        beforeDestroy () {
            // EventBus.$off('drag', this.drag);
            EventBus.$off('dragStart', this.dragStart);
            EventBus.$off('dragEnd', this.dragEnd);
        },
        //------------------------------------------------------------------------------------------------------------------------------------------------
        watch: {
            '$route': function (to, from) {
                this.stationUid = this.$route.params.stationUid;
                this.dayTemplateUid = this.$route.params.dayTemplateUid;
                this.loadDayTemplate();
                this.loadDayTemplateScheduledItemList();
            },
        },
        //------------------------------------------------------------------------------------------------------------------------------------------------
        computed: {
            scheduledItemTypes() {
                return Enums.ScheduledItemTypes;
            },
            Translations: () => Translations,
            intervals: function () {
                var definedZoom = this.viewState.zoomLevels.find(val => val == this.viewState.zoom);
                if (!definedZoom) this.viewState.zoom = definedZoom = 30;
                var stepCount = 1440 / this.viewState.zoom;
                var intervals = [];
                for (var i = 0; i < stepCount; i++) {
                    var tmpDate = Moment().utc().startOf('day').add(i * definedZoom, "m");
                    var tmpDateTo = Moment().utc().startOf('day').add((i + 1) * definedZoom, "m");
                    intervals.push({ minStart: i * definedZoom, minEnd: (i + 1) * definedZoom, timeStart: tmpDate, timeEnd: tmpDateTo, step: i })
                }
                return intervals;
            },
            postData() {
                if (!!Object.keys(this.activeMovingItem).length  && this.activeMovingItem.scheduledItem == null) {
                    return null;
                }
                var draft = Object.assign({}, this.activeMovingItem.scheduledItem);
                draft.stationUid = this.$route.params.stationUid;
                draft.dayTemplateUid = this.$route.params.dayTemplateUid;
                draft.from = this.minToMoment(draft.minuteFrom).format("HH:mm:ss");
                draft.to = this.minToMoment(draft.minuteTo).format("HH:mm:ss");
                draft.minuteFrom = parseInt(draft.minuteFrom);
                draft.minuteTo = parseInt(draft.minuteTo);
                draft.minuteTo = draft.minuteTo === 0 || draft.minuteTo > 1440 ? 1440 : draft.minuteTo;
                return draft;
            },
            currentApi() {
                // SHOULD BE CENTRALIZED
                switch ((this.postData || {}).typeId) {
                    case this.scheduledItemTypes.DAYTEMPLATE_CLOCK.value: return Apis.daytemplates.linkClock;
                    case this.scheduledItemTypes.DAYTEMPLATE_PLAYLIST.value: return Apis.daytemplates.linkPlaylist;
                    case this.scheduledItemTypes.DAYTEMPLATE_PODCAST.value: return Apis.daytemplates.linkPodcast;
                    case this.scheduledItemTypes.DAYTEMPLATE_PROMO.value: return Apis.daytemplates.linkPromo;
                    default: return null;
                }
            },
        },
        //------------------------------------------------------------------------------------------------------------------------------------------------
        data() {
            var defaultMovingItem = { scheduledItem: null };
            return {
                currentDayTemplate: null,
                viewState: {
                    isLoadingDayTemplate: false,
                    zoomLevels: [5, 15, 30, 60],
                    zoom: 30,
                    activatePlaylists: true,
                    activatePodcasts: true,
                    activateClocks: true,
                    defaultMovingItem: defaultMovingItem
                },
                isLoadingDayTemplateItems: true,
                currentDayTemplateItems: null,
                activeMovingItem: defaultMovingItem,
                scheduledItem: null,
                scheduledItemToDelete: null
            }
        },
        //------------------------------------------------------------------------------------------------------------------------------------------------
        methods: {
            onDayTemplateLoaded(response) { this.currentDayTemplate = response.data.dataItem; },
            onDayTemplateLoadError(response) { this.currentDayTemplate = null; },
            onDayTemplateLoadComplete(response) { this.viewState.isLoadingDayTemplate = false; },
            loadDayTemplate: function () {
                this.viewState.isLoadingDayTemplate = true;
                HTTP.get(Apis.daytemplates.details, { params: this.$route.params })
                    .then(this.onDayTemplateLoaded, this.onDayTemplateLoadError)
                    .then(this.onDayTemplateLoadComplete);
                if (this.$route.params != null && this.$route.params.stationUid != null && this.$route.params.dayTemplateUid != null) {
                    store.dispatch("loadDayTemplate", this.$route.params);
                }
            },
            addClock(clock) {
                // console.log("AddClock : ",clock)
                var data = { typeId: this.scheduledItemTypes.DAYTEMPLATE_CLOCK.value, recordUid: null, clockUid: clock.uid, minuteFrom: 0, minuteTo: 1440, name: clock.name, autoSelect: true }
                this.scheduledItem = data;
            },
            addPlaylist(playlist) {
                // console.log("addPlaylist : ",playlist)
                var data = { typeId: this.scheduledItemTypes.DAYTEMPLATE_PLAYLIST.value, recordUid: null, boxuid: playlist.uid, minuteFrom: 0, name: playlist.name }
                this.scheduledItem = data;
            },
            addPodcast(podcast) {
                // console.log("addPodcast : ",podcast)
                var data = { typeId: this.scheduledItemTypes.DAYTEMPLATE_PODCAST.value, recordUid: null, boxuid: podcast.uid, minuteFrom: 0, name: podcast.name, repeat: false, repeatCount: 0, repeatDelay: 60 }
                this.scheduledItem = data;
            },
            //-------------------------------------------------------------------------------------------
            //- Edition & remove actions
            //-------------------------------------------------------------------------------------------
            onScheduledItemListUpdated(response) {
            },
            onScheduledItemEditing(e, data) {
                // console.log('onScheduledItemEditing', data.scheduledItem);
                this.scheduledItem = data.scheduledItem;
                // Open Modal
            },
            onScheduledItemEdited(e, data) {
                // reload items
                this.loadDayTemplateScheduledItemList();
            },
            //-------------------------------------------------------------------------------------------
            //- Api
            //-------------------------------------------------------------------------------------------
            loadDayTemplateScheduledItemList() {
                this.viewState.isLoadingScheduledItems = true;
                HTTP
                    .get(Apis.daytemplates.scheduledItems, { params: { stationUid: this.stationUid, dayTemplateUid: this.dayTemplateUid }})
                    .then(this.onScheduledItemListLoadComplete, this.onClockBoxListLoadError)
                    .then(() => {
                        this.viewState.isLoadingScheduledItems = false;
                    });
            },
            onScheduledItemDeleting(e, data) {
                // console.log('onScheduledItemDeleting', e, data);
                this.scheduledItemToDelete = data.scheduledItem;
                var apiData = {
                    stationUid: this.$route.params.stationUid,
                    dayTemplateUid: this.$route.params.dayTemplateUid,
                    recordUid: data.scheduledItem.recordUid
                };
                HTTP
                    .post(Apis.daytemplates.unlinkItem, apiData)
                    .then(this.onApiSaved, this.onApiError)
                    .then(() => {
                        this.scheduledItemToDelete = null;
                        store.dispatch('loadStationDayTemplates', this.stationUid);
                    });
                // Open Modal
            },
            onScheduledItemListLoadComplete: function (response) {
                this.scheduledListResponse = response.data;
                var data = response.data.dataItem || [];
                this.preparePodcasts(data);
                this.currentDayTemplateItems = data;
                this.isLoadingDayTemplateItems = false;
            },
            onScheduledItemListLoadError: function (error) {
                this.scheduledListResponse = error.response.data;
            },
            onScheduledItemMoved(e) {
                if (!this.activeMovingItem || !this.activeMovingItem.scheduledItem) return;
                HTTP.post(this.currentApi, this.postData)
                    .then(this.onApiSaved, this.onApiError)
                    .then(this.onItemMoved);
            },
            onItemMoved() {
                this.activeMovingItem = this.viewState.defaultMovingItem;
                this.preparePodcasts(this.currentDayTemplateItems);
                // update left boxList
                this.$store.dispatch('loadStationDayTemplates', this.$route.params.stationUid)

            },
            refreshData(response) {
                // console.log(JSON.stringify(response));
                this.scheduledListResponse = response;
                var data = response.dataItem || [];
                this.preparePodcasts(data);
                this.currentDayTemplateItems = data;
            },
            onApiSaved(httpResponse) {
                // console.log("onApiSaved -> ", httpResponse);
                this.apiResponse = httpResponse.data;
                this.refreshData(this.apiResponse);
                this.activeMovingItem = {};
                store.dispatch('loadStationDayTemplates', this.stationUid);
            },
            onApiError(error) {
                this.apiResponse = error.response.data;
                this.refreshData(this.apiResponse);
                console.error(this.apiResponse);
            },
            //-------------------------------------------------------------------------------------------
            //- Tools
            //-------------------------------------------------------------------------------------------
            preparePodcasts(data) {
                if (!data) return;
                var workingData = (data.podcasts || []).sort(function (a, b) { return b.minuteFrom - a.minuteFrom });
                //console.log(JSON.stringify(data.podcasts));
                //console.log("Redraw podcasts");
                // To Force the display if more than one podcast at the same period
                var intervalPodcasts = {}
                for (var i = 0; i < workingData.length; i++) {
                    var pod = workingData[i];
                    for (var idx = 0; idx < this.intervals.length; idx++) {
                        var interval = this.intervals[idx];
                        if (pod.minuteFrom >= interval.minStart && pod.minuteFrom < interval.minEnd) {
                            intervalPodcasts[idx] = (intervalPodcasts[idx] || {});
                            //intervalPodcasts[idx + 1] = (intervalPodcasts[idx + 1] || {});
                            var idxKeys = intervalPodcasts[idx];
                            if (idxKeys[pod.recordUid]) continue;
                            pod.interval = {
                                idx, limits: interval, displayOrder: Object.keys((intervalPodcasts[idx] || {})).length || 0
                            };
                            intervalPodcasts[idx][pod.recordUid] = true;
                            //intervalPodcasts[idx + 1][pod.recordUid] = true;
                        }
                    }
                }
                for (var i = 0; i < workingData.length; i++) {
                    var pod = workingData[i];
                    //console.log(JSON.stringify(pod.recordUid), pod.interval.idx, Object.keys((intervalPodcasts[pod.interval.idx])).length);
                    pod.interval.ratio = 100 / (Object.keys((intervalPodcasts[pod.interval.idx] || {})).length || 1);
                    //console.log(pod.recordUid, "----->xx", pod.interval.ratio, pod.interval.displayOrder);
                    Vue.set(pod, 'interval', pod.interval);
                }
            },
            pxToMin(position, height) {
                return 1440 * (position / height);
            },
            //-------------------------------------------------------------------------------------------
            //- Moving
            //-------------------------------------------------------------------------------------------
            onScheduledItemStartMoving(e, data) {
                //console.log("onScheduleItemMoving");
                var source = [];
                switch (data.type) {
                    case "clock": source = this.currentDayTemplateItems.clocks; break;
                    case "playlist": source = this.currentDayTemplateItems.playlists; break;
                    case "podcast": source = this.currentDayTemplateItems.podcasts; break;
                }
                source = source.filter(elt => elt.recordUid !== data.scheduledItem.recordUid);
                this.activeMovingItem = this.buildMovingData(e, source, data);
                //console.log("onScheduleItemMoving", JSON.stringify(this.activeMovingItem));
            },
            buildMovingData(e, source, data) {
                //console.log("BuildMovingData")
                var scrollingParent = null;
                var cardParent = null;
                var originalScrollPosition = 0;
                var parentTmp = e.currentTarget;
                if (parentTmp.classList.contains('dt-item-card')) {
                    cardParent = parentTmp;
                }
                while ((parentTmp = parentTmp.parentElement) != null) {
                    if (parentTmp.classList.contains('dt-item-card')) {
                        cardParent = parentTmp;
                    }
                    if (parentTmp.classList.contains("drop-zones-container")) {
                        //console.log(parentTmp, parentTmp.offsetHeight);
                        scrollingParent = parentTmp;
                        originalScrollPosition = parentTmp.scrollTop;
                        break;
                    }
                }

                var movingData = {

                    scheduledItem: data.scheduledItem,
                    mode: data.mode,
                    up: data.up,
                    min: 0,// beginning of a day
                    max: 1440, // total minutes in a day

                    originalStart: data.scheduledItem.minuteFrom,
                    originalEnd: data.scheduledItem.minuteTo,

                    originalMousePosition: { clientX: e.clientX, clientY: e.clientY },
                    containerHeight: scrollingParent.offsetHeight,
                    height: cardParent.offsetHeight,// Scheduled Item Card
                };
                for (var i = 0; i < source.length; i++) {
                    //------------------------------------------------------
                    var candidate = source[i];
                    var candidateFrom = candidate.minuteFrom;
                    var candidateTo = candidate.minuteTo;
                    var currentFrom = data.scheduledItem.minuteFrom;
                    var currentTo = data.scheduledItem.minuteTo;
                    //------------------------------------------------------
                    if (candidateFrom < currentFrom) {
                        movingData.min = candidateTo > movingData.min ? candidateTo : movingData.min;
                    }
                    else {
                        movingData.max = candidateFrom < movingData.max ? candidateFrom : movingData.max;
                    }
                    //------------------------------------------------------
                }
                //console.log(JSON.stringify(movingData));
                return movingData;
            },
            onPodcastMove(e) {
                if (this.activeMovingItem == null) return;
                try {
                    this.onScheduledItemMove(e);
                } catch (e) {
                    console.log(e);
                }
                finally {
                    this.preparePodcasts(this.currentDayTemplateItems);
                }
            },
            onScheduledItemMove(e) {
                if (safeObj(this.activeMovingItem) && this.activeMovingItem.scheduledItem === null) {
                    return;
                }
                if (e.buttons === 1) {
                    var sch = this.activeMovingItem;
                    //console.log("Initial value : ", JSON.stringify(sch))
                    //console.log("Initial value : ", sch.scheduledItem.minuteFrom)
                    var pixDecal = e.clientY - ((sch.originalMousePosition || {}).clientY || 0);
                    //console.log("Décalage Pixels : ", pixDecal, sch.containerHeight)
                    //-----------------------------------------------------------
                    // Convert pix decal to minutes
                    //-----------------------------------------------------------
                    var mDecal = this.pxToMin(pixDecal, sch.containerHeight);
                    //-----------------------------------------------------------
                    // Check Start
                    //-----------------------------------------------------------
                    if (sch.mode === MOVING_MODES.MOVE || sch.up === true) {
                        sch.newStart = sch.originalStart + mDecal;
                        if (sch.newStart < 0) { sch.newStart = 0; }
                        if (sch.newStart < sch.min) sch.newStart = sch.min;
                        // Move only up
                        if (sch.mode === MOVING_MODES.MOVE) {
                            // console.log("Move Only : ")
                            if (sch.newStart + sch.scheduledItem.minuteDuration > sch.max)
                                sch.newStart = sch.max - (sch.scheduledItem.minuteDuration);
                        } else if (sch.up) {
                            // console.log("Resize up : ", sch.newStart)
                            sch.scheduledItem.minuteDuration = sch.scheduledItem.minuteTo - sch.newStart;
                        }
                    }
                    else {
                        sch.newStart = sch.originalStart;
                        // Check to not override day
                        sch.newEnd = Math.min(sch.originalEnd + mDecal, 1440);
                        sch.scheduledItem.minuteDuration = sch.newEnd - sch.newStart;
                        // Resize Down
                        //console.log("Resize down : ", sch.newEnd)
                    }

                    //-----------------------------------------------------------
                    // Check End
                    //-----------------------------------------------------------
                    sch.newEnd = sch.newStart + sch.scheduledItem.minuteDuration;
                    if (sch.newEnd > 1440) { sch.newEnd = 1440; sch.newStart = sch.newEnd - sch.scheduledItem.minuteDuration }
                    if (sch.newEnd > sch.max) sch.newEnd = sch.max;
                    //console.log("-> new end : ",sch.newEnd);

                    // Validate render
                    sch.scheduledItem.minuteFrom = sch.newStart;
                    if (sch.scheduledItem.minuteTo != null)
                        sch.scheduledItem.minuteTo = sch.newEnd;
                }

            },
            // DnD
            dragStart(e, item, type) {
                this.current = { item, type};
            },
            dragOver(e) {
                // Fix for drop to launch
                e.preventDefault();
            },
            dragEnd(e, item) {
                this.current = null;
            },
            drop(e) {
                if (!this.current) {
                    return;
                }

                switch (this.current.type) {
                    case 'clock':
                        this.addClock(this.current.item);
                        break;
                    case 'playlist':
                        this.addPlaylist(this.current.item);
                        break;
                    default:
                        this.addPodcast(this.current.item);
                        break;
                }
            }
        }
    }

</script>
<style lang="scss" scoped>

    .drop-zones-header {
        padding-left: 60px;
        padding-right: 10px;
        background: white;
        display: flex;
        color: #AAAAAA;
        font-size: 13px;
        justify-content: space-between;
        line-height: 48px;
        /* Sticky config ----------------------*/
        position: sticky;
        z-index: 10;
        top:0;

        &::before {
            content: '';
            position: absolute;
            left: -15px;
            bottom: 0;
            z-index: -1;
            width: calc(100% + 30px);
            height: 1px;
            background-color: #D2D2D2;
        }

        &::after {
            content: '';
            position: absolute;
            left: -15px;
            bottom: 0;
            z-index: -2;
            width: calc(100% + 30px);
            height: 100%;
            background-color: #fff;
        }
    }

        .drop-zones-header > div {
            width: 33%;
            margin: 0 5px;
            padding: 18px 0;
            line-height: 1;
            text-align: center;
        }

            .drop-zones-header > div.activated {
                font-weight: 600;
            }

    .drop-zones {
        position: relative;
        z-index: 1;
        justify-content: space-between;
        margin: 15px 0 35px 0;


        &::before {
            content: '';
            position: absolute;
            left: -15px;
            top: -15px;
            z-index: -1;
            width: calc(100% + 30px);
            height: calc(100% + 65px);
            background-color: #F5F6F7;
        }
    }


    .drop-zones-container {
        position: absolute;
        top: 0;
        display: flex;
        height: 100%;
        width: calc(100% - 60px);
        margin-left: 50px;
        justify-content: space-between;
    }

        .drop-zones-container > div {
            height: 100%;
            flex-grow: 1;
            /*background: rgba(255, 255,255,0.5);*/
            margin: 0 5px;
            position: relative;
            width: 33%;
        }

    .time-line-row {
        display: flex;
        height: 40px;
    }

        .time-line-row:last-child {
            border-bottom: 1px solid #D2D2D2;
        }

    .helper {
        border-top: 1px solid #D2D2D2;
        width: 100%;
        margin-left: 10px;
    }

    .time-line-label {
        font-size: 13px;
        line-height: 40px;
        color: #888888;
        font-weight: 400;
        margin-top: -20px;
    }
</style>
